import { createReducer } from '../utils/';
import { combineReducers } from 'redux';
import constant from '../utils/constant';

const list = {
    [constant.GETUSERLIST](state, action) {
        return action.payload;
    }
};
const pageState = {
    [constant.SHOWUSERLOADING](state, action) {
        return { ...state, loading: action.payload };
    },
    [constant.SHOWUSEREDIT](state, action) {
        return { ...state, editing: action.payload };
    },
    [constant.SHOWUSERADD](state, action) {
        return { ...state, adding: action.payload };
    },
    [constant.GETPAGETOTAL](state, action) {
        return { ...state, pageTotal: action.payload };
    }
};
const detail={
    [constant.GETDETAIL](state, action) {
        return action.payload;
    },
}
export const userList = createReducer([], list); // 用户列表
export const userpageState = createReducer({ loading: true, editing: false, adding: false,pageTotal:0}, pageState); // 状态数据
export const userDetail = createReducer({}, detail); // 用户信息
export const user = combineReducers({
    userList,
    userpageState,
    userDetail
});



// WEBPACK FOOTER //
// ./reducers/user.js